import React, { Component } from 'react';
import propTypes from 'prop-types';

import { Button, Modal } from '@tcc/crate';
import { getMessage } from 'util/locale';

class ErrorBoundary extends Component {
  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    // Any error tracking tools are used here
    this.props.onError(error, info);
  }

  render() {
    const { children, errorTitleKey, errorBodyKey } = this.props;

    if (this.state.hasError) {
      return (
        <Modal
          show
          size="M"
        >
          <div style={{ textAlign: 'center' }}>
            <h1>{getMessage(errorTitleKey)}</h1>
            <p>{getMessage(errorBodyKey)}</p>
            <br/>
            <Button
              mode="primary"
              onClick={() => window.location.reload()}
            >
              {getMessage('button-text__reload-page')}
            </Button>
          </div>
        </Modal>
      );
    }

    return children;
  }
}

ErrorBoundary.propTypes = {
  children: propTypes.node.isRequired,
  error: propTypes.object.isRequired,
  errorBodyKey: propTypes.string,
  errorTitleKey: propTypes.string.isRequired,
  onError: propTypes.func
};

ErrorBoundary.defaultProps = {
  errorBodyKey: 'help-text__failure--generic--internal-failure--body',
  errorTitleKey: 'help-text__failure--generic--internal-failure--title',
  onError: () => {}
};

export default ErrorBoundary;
